// extracted by mini-css-extract-plugin
module.exports = {"destination-carousel-component":"destination-carousel_destination-carousel-component__qC1By"};